angular
    .module('festzelt-os.components')
    .filter('random', [
        random
    ]);

function random() {
    return function (input, min, max) {

        min = parseInt(min);
        max = parseInt(max);

        return min + parseInt(Math.random() * (max - min));

    };
}



// WEBPACK FOOTER //
// ./src/app/components/filters/random.js